/* Tiny global signal for "an answer failed to save permanently" (reliability
 * fast-follow). Queueable failures are handled optimistically by the offline
 * outbox; this is only the permanent-error path the drills used to swallow.
 * A single globally-mounted toast subscribes; drills just call reportSubmitError
 * in their submitAttempt .catch — no per-drill state or render. */

type Listener = (message: string) => void;
const listeners = new Set<Listener>();

export function reportSubmitError(message: string): void {
  for (const l of listeners) l(message);
}

export function subscribeSubmitError(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
